import { CASE_SPLIT_PATTERN } from '../../string/words.mjs';
import { toString } from '../util/toString.mjs';

function words(str, pattern = CASE_SPLIT_PATTERN, guard) {
    const input = toString(str);
    pattern = guard ? CASE_SPLIT_PATTERN : pattern;
    const words = Array.from(input.match(pattern) ?? []);
    return words.filter(x => x !== '');
}

export { words };
